<!--
  Copyright (c) 2023-2026, NVIDIA CORPORATION.  All rights reserved.

  NVIDIA CORPORATION and its licensors retain all intellectual property
  and proprietary rights in and to this software, related documentation
  and any modifications thereto.  Any use, reproduction, disclosure or
  distribution of this software and related documentation without an express
  license agreement from NVIDIA CORPORATION is strictly prohibited.
-->
<div class="common-overlay" fxLayoutAlign="center center">
    <mat-progress-spinner
        class="mat-accent"
        [mode]="mode"
        [diameter]="diameter"
        [value]="value"
        [attr.aria-label]="'loading' | translate"
    >
    </mat-progress-spinner>
</div>
